module.exports = __webpack_public_path__ + "static/media/playlist-play-icon.07c29fb9.svg";